module.exports = __webpack_public_path__ + "img/step-icon-loading.fe1aa232.svg";